<template>
    <div>
        <v-select
            v-model="panelId"
            :multiple="false"
            :options="options"
            :close-on-select="true"
            label="reporting_label"
            class="mw-100"
            placeholder="Select an inquiry..."
            :reduce="(option) => option.id"
            v-on:input="$emit('input', panelId)"
        >
            <template slot="option" slot-scope="option">
                <span class="badge badge-pill badge-light align-middle">Screen {{ option.node.number }}</span>
                <span class="align-middle medium ml-1">
                    <span>{{ option.reporting_label || option.header }}</span>
                </span>
                <span class="badge badge-pill badge-light align-middle font-weight-500 ml-1 small">
                    <span class="align-middle mr-1">{{ panelTypeLabel(option.panel_type) }}</span>
                    <span class="align-middle icon" :class="[panelTypeIcon(option.panel_type)]"></span>
                </span>
            </template>
            <template v-slot:selected-option="option">
                <div>
                    <span class="badge badge-pill badge-light">Screen {{ option.node.number }}</span>
                    <span class="align-middle medium ml-1">
                        <span>{{ option.reporting_label || option.header }}</span>
                    </span>
                    <span class="badge badge-pill badge-light align-middle font-weight-500 ml-1 small">
                        <span class="align-middle mr-1">{{ panelTypeLabel(option.panel_type) }}</span>
                        <span class="align-middle icon" :class="[panelTypeIcon(option.panel_type)]"></span>
                    </span>
                </div>
            </template>
            <template slot="no-options">
                <span class="text-secondary">No inquiries to display.</span>
            </template>
        </v-select>
    </div>
</template>

<script>
import { panelTypeIcons, panelTypeLabels } from "@/assets/js/settings.js"

export default {
    name: "ReportPanelSelector",
    props: {
        value: {
            type: Number,
            required: false,
        },
        options: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            panelId: this.value,
        }
    },
    watch: {
        value: function (newValue) {
            this.panelId = newValue
        },
    },
    methods: {
        panelTypeIcon(panelType) {
            return panelTypeIcons[panelType]
        },
        panelTypeLabel(panelType) {
            let label = ""
            try {
                label = panelTypeLabels[panelType]
            } catch (error) {
                label = "Content"
            }
            return label
        },
    },
}
</script>

<style>
</style>